module.exports = {
      id: "bullet-arrow-usage",
      viewBox: "0 0 22 20",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#bullet-arrow",
      toString: function () {
        return this.url;
      }
    }